import {styledDiv} from '@packages/utilities/styled';
import {list, shadow, black} from '@packages/utilities/inline-style-utils';
import {unselectable} from './constants/Styles';

// @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type. | TS7031 - Binding element 'style' implicitly has an 'any' type.
const knobStyle = ({theme, style}) => ({
  borderRadius: 9999,
  backgroundColor: theme.colors.controlVivid,
  boxShadow: list(
    // This transparent shadow is here to work around a Chrome bug which causes
    // the real shadow to be cut off when applying transforms on the element.
    shadow(0, 0, 0, 1, black(0)),
    shadow(0, 0, 0, 0.5, black(0.3))
  ),
  ...style,
});

const knobVariants = {
  disabled: {
    boxShadow: 'none',
    ...unselectable,
  },
} as const;

const Knob = styledDiv(knobStyle, knobVariants);
Knob.displayName = 'Knob';
export default Knob;
